import { GridColumn, GridRow } from "@metsooutotec/modes-react-components"
import { observer } from "mobx-react-lite"
import AssetSectionEditorDetails from "../asset-section-editor-details"
import AssetSectionEditorsettings from "../asset-section-editor-settings"
import { EditorSteps } from "../editor-utils/editor-types"
import asEditorStore from "./../local-store/asset-section-editor-store"
import { AssetSection, EditingAssetSectionWindow } from "features/organizations/asset-sections/models/asset-section-models"
import { Asset } from "features/organizations/assets/models/asset-models"

interface FirstColumnParams {
    asset: Asset
    assetSection: AssetSection
    newEditAssetSection: EditingAssetSectionWindow
    setNewEditAssetSection: React.Dispatch<React.SetStateAction<EditingAssetSectionWindow>>
    errorMessage: string
}

export const FirstColumnEditor: React.FC<FirstColumnParams> = observer(params => {
    const { asset, assetSection, newEditAssetSection, setNewEditAssetSection, errorMessage } = params

    return (
        <GridColumn className='first-column'>
            <GridRow className='first-row'>
                <div>
                    <p className='asset-section-name'>
                        <strong>{assetSection.name}</strong>
                    </p>
                    <p className='asset-name'>Asset section for asset: {asset.name}</p>
                </div>
            </GridRow>
            {
                /** If it's in the first step (Asset Section Details and SVG Settings) stage */
                asEditorStore.currentStep === EditorSteps.SVGSettings && (
                    <GridRow className='second-row' stretched>
                        <AssetSectionDetailsFields
                            assetSection={assetSection}
                            errorMessage={errorMessage}
                            newEditAssetSection={newEditAssetSection}
                            setNewEditAssetSection={setNewEditAssetSection}
                        />
                        <AssetSectionEditorsettings />
                    </GridRow>
                )
            }
        </GridColumn>
    )
})

interface AssetSectionDetailsFieldsParams {
    assetSection: AssetSection
    newEditAssetSection: EditingAssetSectionWindow
    setNewEditAssetSection: React.Dispatch<React.SetStateAction<EditingAssetSectionWindow>>
    errorMessage: string
}

const AssetSectionDetailsFields: React.FC<AssetSectionDetailsFieldsParams> = params => {
    const { assetSection, newEditAssetSection, setNewEditAssetSection, errorMessage } = params

    return (
        <AssetSectionEditorDetails
            assetSection={assetSection}
            editAssetSection={newEditAssetSection}
            setEditAssetSection={setNewEditAssetSection}
            errorMessage={errorMessage}
        />
    )
}
